import { makeStyles } from "tss-react/mui";

// The status cards in a row are equally tall but their text can wrap onto a second line, so the bar is pinned to the
// bottom of each card to keep all bars on one line.
export const useStatusCardStyles = makeStyles()(() => ({
    progressBar: {
        marginTop: "auto",
    },
}));
